// src/routes.js

// Layouts
import Dashboard from "layouts/dashboard";
import Screens from "layouts/screens";
import Media from "layouts/media";
import Invoices from "layouts/invoices";
import Profile from "layouts/profile";
import SignIn from "layouts/authentication/sign-in";
import MessengerPage from "layouts/messenger";
import Campaigns from "layouts/campaigns";


// @mui icons
import Icon from "@mui/material/Icon";

const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: <Dashboard />,
    private: true, // 🔐 nur nach Login
  },
  {
    type: "collapse",
    name: "Bildschirme",
    key: "screens",
    icon: <Icon fontSize="small">tv</Icon>,
    route: "/screens",
    component: <Screens />,
    private: true,
  },
  {
    type: "collapse",
    name: "Medien",
    key: "media",
    icon: <Icon fontSize="small">perm_media</Icon>,
    route: "/media",
    component: <Media />,
    private: true,
  },
  {
    type: "collapse",
    name: "Rechnungen",
    key: "invoices",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/invoices",
    component: <Invoices />,
    private: true,
  },
  {
    type: "collapse",
    name: "Messenger",
    key: "messenger",
    icon: <Icon fontSize="small">forum</Icon>,
    route: "/messenger",
    component: <MessengerPage />,
    private: true,
  },
  {
    type: "collapse",
    name: "Kampagnen",
    key: "campaigns",
    icon: <Icon fontSize="small">event</Icon>,
    route: "/campaigns",
    component: <Campaigns />,
    private: true,
  },
  // 👇 NEU: Profil-Seite, aber NICHT im Sidenav
  {
    type: "hidden",              // kein "collapse" → Sidenav ignoriert sie
    name: "Profil",
    key: "profile",
    route: "/profile",
    component: <Profile />,
    private: true,
  },


  // Login-Route (taucht NICHT in der Sidebar auf)
  {
    type: "auth",
    name: "Sign In",
    key: "sign-in",
    route: "/authentication/sign-in",
    component: <SignIn />,
    private: false,
  },
];

export default routes;
